import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=4b3318bf&scoped=true"
import script from "./Statuses.vue?vue&type=script&lang=js"
export * from "./Statuses.vue?vue&type=script&lang=js"
import style0 from "./Statuses.vue?vue&type=style&index=0&id=4b3318bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3318bf",
  null
  
)

export default component.exports